import { computed, onMounted, reactive, toRefs, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'
// 兼容app传值
import qs from '@halobear/utils/qs'
import * as Api from '@/api/travel'
import { toast } from '@/utils/feedback'
import { getToken } from '@/utils/authority'
import { handle401 } from '@/utils/handle'
import { notifyCollect } from '@/api/app'
import { startTime, destoryTime } from '@/constants/computed-time'

const isDev = process.env.NODE_ENV === 'development'

export default () => {
  const state = reactive({
    picture: [],
    tags: [],
    data: {},
    list: [],
    collectMap: {},
    hallDetail: {},
  })

  const route = useRoute()

  const targetHall = computed(() => {
    const hall_id = route.query.hall_id || qs.get('hall_id')
    return state.list.find((item) => item.hall_id == hall_id) || {}
  })

  const share = () => {
    const hall_id = route.query.hall_id || qs.get('hall_id')
    const hotel_id = route.query.hotel_id || qs.get('hotel_id')
    const target = state.list.find((item) => item.hall_id == hall_id) || {}
    const title = target.name ? `${state.data.name} ${target.name}` : state.data.name
    const url = `${location.origin}${location.pathname}?hall_id=${hall_id}&hotel_id=${hotel_id}&title=${title}`
    const path = `/pages/webview/index?url=${encodeURIComponent(url)}&title=${title}`
    const { cover } = targetHall.value
    cover &&
      window.wx &&
      wx.miniProgram.postMessage({
        data: { title, path, imageUrl: cover },
      })
  }

  const fetchList = async () => {
    const { hotel_id = isDev ? 1750 : '' } = route.query.hotel_id
      ? route.query
      : qs.parse(window.location.search.split('?')[1])
    const data = await Api.halls(hotel_id)
    state.data = data.hotel || {}
    state.list = data.list || []
    // 自定义微信小程序分享内容
    share()
  }

  const fetchHallDetail = async () => {
    const { hall_id = isDev ? 7397 : '', phone } = route.query.hotel_id
      ? route.query
      : qs.parse(window.location.search.split('?')[1])
    const data = await Api.hallDetail(hall_id, phone ? 1 : 0)
    state.hallDetail = data
  }

  const fetchCollect = async () => {
    // 没有登录不处理
    if (!getToken()) return
    const { list = [] } = await Api.collectList()
    const collectMap = {}
    list.forEach((item) => {
      collectMap[item.id] = 1
    })
    state.collectMap = collectMap
  }

  const collect = async () => {
    if (!getToken()) return handle401()
    const id = route.query.hall_id || qs.get('hall_id')
    const { title } = await Api.toggleCollect(id)
    title && toast(title)

    // 刷新收藏列表
    fetchCollect()
    // 通知app收藏修改
    notifyCollect()
  }

  const hallTitle = computed(() => {
    return targetHall.value.name
  })

  const isCollect = computed(() => {
    const hall_id = route.query.hall_id || qs.get('hall_id')
    return !!state.collectMap[hall_id]
  })

  const hallCate = computed(() => {
    const cateMap = {
      7: 1, // '泳池',
      8: 1, // '沙滩',
      9: 1, // '教堂',
      10: 1, // '草坪',
      3: 1, // '迎宾区',
      11: 1, // '水台'
      4: 2, // '宴会厅',
    }
    return cateMap[state.hallDetail.type]
  })

  onMounted(async () => {
    fetchHallDetail()
    await fetchList()
    // fetchCollect()

    const hall_id = route.query.hall_id || qs.get('hall_id')
    const hotel_id = route.query.hotel_id || qs.get('hotel_id')
    startTime({
      action: {
        id: 'halldetail_show',
        action: '场地详情-统计时长',
        label: `${hotel_id}-${hall_id}-${state.data.name}`,
      },
      data: { ...state.data, hall_name: hallTitle.value || '暂无场地名' },
      key: 'place',
    })
  })

  onBeforeUnmount(() => {
    destoryTime()
  })

  return {
    ...toRefs(state),
    share,
    targetHall,
    fetchList,
    fetchHallDetail,
    collect,
    hallTitle,
    isCollect,
    hallCate,
  }
}
